var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"swiper-container",class:_vm.$style.container},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_c('div',{staticClass:"swiper-pagination"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }